module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1015-a3d205c65871bf5d6a56b19c9a0680cf.png";